<template>
  <div v-show="isShow.isPTShow" class="pageTwo" :class="isSlideIn ? 'slideIn' : ''">
    <div class="pt-wrapper">
      <img class="mergedImg" :src="mergedSrc" alt="">
      <div class="index">
        <span class="idx idx1">{{idx1}}%</span>
        <span class="idx idx2">{{idx2}}%</span>
        <span class="idx idx3">{{idx3}}%</span>
        <span class="illusSub illus-left" :class="calcClass.illusSub1"></span>
        <span class="illusSub illus-right" :class="calcClass.illusSub2"></span>
      </div>
      <div class="person-title">{{person}}获得<span class="pt-title">{{title}}</span>称号</div>
      <div :class="calcClass.desc" class="desc"></div>
      <div class="ils-wrapper">
        <div class="illustration" :class="calcClass.illus"></div>
        <div class="ils-desc"></div>
        <span class="long-press"></span>
      </div>
      <div class="btn-group">
        <span class="btn btn-left" @click="playAgain"></span>
        <span class="btn btn-right" @click="showMask"></span>
      </div>
      <div class="logo-group">
        <span class="logo logo-left"></span>
        <span class="logo logo-right"></span>
      </div>
    </div>
    <div id="myCanvas"></div>
    <div class="mask" v-show="isMask" @click="hideMask">
      <div class="router"></div>
    </div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';
import { imgData } from './imgData.js';

let Application = PIXI.Application;
let Sprite = PIXI.Sprite;
let Text = PIXI.Text;

export default {
  name: 'PageTwo',
  props: {
    isShow: {
      type: Object
    },
    person: {
      type: String,
      default: ''
    },
    idx1: {
      type: Number,
      default: 80
    },
    idx2: {
      type: Number,
      default: 83
    },
    idx3: {
      type: Number,
      default: 82
    },
    selectedOne: {
      type: Number,
      default: 6
    },
    title: {
      type: String,
      default: '创新天才'
    },
  },
  data () {
    return {
      // idx1: 88,
      // idx2: 72,
      // idx3: 92,
      // person: 'Mercy',
      isSlideIn: false,
      // title: '创新天才',
      // selectedOne: 5,
      isMask: false,
      mergedSrc: '',
      mergeImgData: imgData,
      cmLogoHW: require('./logo-hw.png'),
      cmLogoGK: require('./logo-gk.png'),
      cmDesc: require('./poster-common-desc.png'),
      cmNotice: require('./fn-desc.png'),
      cmQR: require('./temp-qr.png'),
      cmIndex: require('./poster-common-index.png'),
      cmBg: require('./fn-bg.jpg'),
      imgDesc1: require('./poster1-desc.png'),
      imgDesc2: require('./poster2-desc.png'),
      imgDesc3: require('./poster3-desc.png'),
      imgDesc4: require('./poster4-desc.png'),
      imgDesc5: require('./poster5-desc.png'),
      imgDesc6: require('./poster6-desc.png'),
      imgDesc7: require('./poster7-desc.png'),
      imgDesc8: require('./poster8-desc.png'),
      imgIllus1: require('./poster1-main.png'),
      imgIllus2: require('./poster2-main.png'),
      imgIllus3: require('./poster3-main.png'),
      imgIllus4: require('./poster4-main.png'),
      imgIllus5: require('./poster5-main.png'),
      imgIllus6: require('./poster6-main.png'),
      imgIllus7: require('./poster7-main.png'),
      imgIllus8: require('./poster8-main.png'),
      imgIllusSub12: require('./poster1-sub1.png'),
      imgIllusSub21: require('./poster2-sub1.png'),
      imgIllusSub22: require('./poster2-sub2.png'),
      imgIllusSub31: require('./poster3-sub1.png'),
      imgIllusSub32: require('./poster3-sub2.png'),
      imgIllusSub41: require('./poster4-sub1.png'),
      imgIllusSub42: require('./poster4-sub2.png'),
      imgIllusSub51: require('./poster5-sub1.png'),
      imgIllusSub52: require('./poster5-sub2.png'),
      imgIllusSub61: require('./poster6-sub1.png'),
      imgIllusSub62: require('./poster6-sub2.png'),
      imgIllusSub71: require('./poster7-sub1.png'),
      imgIllusSub81: require('./poster8-sub1.png'),
      imgIllusSub82: require('./poster8-sub2.png'),
    }
  },
  computed: {
    calcClass () {
      let selectedOne = this.selectedOne;
      switch (selectedOne) {
        case 1:
          return {
            desc: 'desc1',
            illus: 'illus1',
            illusSub1: 'illusSub11',
            illusSub2: 'illusSub12',
            imgDesc: this.imgDesc1,
            imgIllus: this.imgIllus1,
            sub1: '',
            sub2: this.imgIllusSub12,
          }
        case 2:
          return {
            desc: 'desc2',
            illus: 'illus2',
            illusSub1: 'illusSub21',
            illusSub2: 'illusSub22',
            imgDesc: this.imgDesc2,
            imgIllus: this.imgIllus2,
            sub1: this.imgIllusSub21,
            sub2: this.imgIllusSub22
          }
        case 3:
          return {
            desc: 'desc3',
            illus: 'illus3',
            illusSub1: 'illusSub31',
            illusSub2: 'illusSub32',
            imgDesc: this.imgDesc3,
            imgIllus: this.imgIllus3,
            sub1: this.imgIllusSub31,
            sub2: this.imgIllusSub32
          }
        case 4:
          return {
            desc: 'desc4',
            illus: 'illus4',
            illusSub1: 'illusSub41',
            illusSub2: 'illusSub42',
            imgDesc: this.imgDesc4,
            imgIllus: this.imgIllus4,
            sub1: this.imgIllusSub41,
            sub2: this.imgIllusSub42
          }
        case 5:
          return {
            desc: 'desc5',
            illus: 'illus5',
            illusSub1: 'illusSub51',
            illusSub2: 'illusSub52',
            imgDesc: this.imgDesc5,
            imgIllus: this.imgIllus5,
            sub1: this.imgIllusSub51,
            sub2: this.imgIllusSub52
          }
        case 6:
          return {
            desc: 'desc6',
            illus: 'illus6',
            illusSub1: 'illusSub61',
            illusSub2: 'illusSub62',
            imgDesc: this.imgDesc6,
            imgIllus: this.imgIllus6,
            sub1: this.imgIllusSub61,
            sub2: this.imgIllusSub62
          }
        case 7:
          return {
            desc: 'desc7',
            illus: 'illus7',
            illusSub1: 'illusSub71',
            illusSub2: 'illusSub72',
            imgDesc: this.imgDesc7,
            imgIllus: this.imgIllus7,
            sub1: this.imgIllusSub71,
            sub2: ''
          }
        case 8:
          return {
            desc: 'desc8',
            illus: 'illus8',
            illusSub1: 'illusSub81',
            illusSub2: 'illusSub82',
            imgDesc: this.imgDesc8,
            imgIllus: this.imgIllus8,
            sub1: this.imgIllusSub81,
            sub2: this.imgIllusSub82
          }
        default:
          return {
            desc: 'desc1',
            illus: 'illus1',
            illusSub1: 'illusSub11',
            illusSub2: 'illusSub12',
            imgDesc: this.imgDesc1,
            imgIllus: this.imgIllus1,
            sub1: '',
            sub2: this.imgIllusSub12
          }
      }
    }
  },
  methods: {
    playAgain () {
      window.location.href = 'https://www.jiandoukeji.com/h5/2018/guoke2018/index.html';
    },
    showNext () {
      this.isShow.isPTShow = false
      this.isShow.isKVShow = true
    },
    showMask () {
      // this.$emit('hvDirective', {name: 'm06'});
      this.isMask = true;
    },
    hideMask () {
      this.isMask = false;
    },
    mergeImg () {
      let appStage = new Application({
        width: 750,
        height: 1334,
        antialias: true,
        transparent: true,
        resolution: 1
      });

      const myCanvas = document.getElementById('myCanvas');
      myCanvas.appendChild(appStage.view);
      const selectedOne = this.selectedOne;
      const mySelected = this.mergeImgData[selectedOne];

      let container = new PIXI.Container();
      let bgImg = PIXI.Texture.fromImage(this.cmBg);
      let bgSpr = new Sprite(bgImg);
      bgSpr.width = 750;
      bgSpr.height = 1334;
      container.addChild(bgSpr);

      // 指数
      let indexImg = PIXI.Texture.fromImage(this.cmIndex);
      let indexSpr = new Sprite(indexImg);
      indexSpr.width = 589;
      indexSpr.height = 192;
      indexSpr.anchor.set(.5, .5);
      indexSpr.position.set(375, 170);
      container.addChild(indexSpr);

      // 描述
      let DescImg = PIXI.Texture.fromImage(this.cmDesc);
      let DescSpr = new Sprite(DescImg);
      DescSpr.width = 514;
      DescSpr.height = 65;
      DescSpr.anchor.set(.5, .5);
      DescSpr.position.set(375, 920);
      container.addChild(DescSpr);

      // 二维码
      let QRImg = PIXI.Texture.fromImage(this.cmQR);
      let QRSpr = new Sprite(QRImg);
      QRSpr.width = 146;
      QRSpr.height = 153;
      QRSpr.anchor.set(.5, .5);
      QRSpr.position.set(375, 1060);
      container.addChild(QRSpr);

      // 二维码
      let NoticeImg = PIXI.Texture.fromImage(this.cmNotice);
      let NoticeSpr = new Sprite(NoticeImg);
      NoticeSpr.width = 314;
      NoticeSpr.height = 25;
      NoticeSpr.anchor.set(.5, .5);
      NoticeSpr.position.set(375, 1180);
      container.addChild(NoticeSpr);

      // 华为 logo
      let HWImg = PIXI.Texture.fromImage(this.cmLogoHW);
      let HWSpr = new Sprite(HWImg);
      HWSpr.width = 93;
      HWSpr.height = 93;
      HWSpr.anchor.set(.5, .5);
      HWSpr.position.set(258, 1254);
      container.addChild(HWSpr);

      // 华为 logo
      let GKImg = PIXI.Texture.fromImage(this.cmLogoGK);
      let GKSpr = new Sprite(GKImg);
      GKSpr.width = 93;
      GKSpr.height = 93;
      GKSpr.anchor.set(.5, .5);
      GKSpr.position.set(490, 1254);
      container.addChild(GKSpr);

      // 海报描述
      let myDescImg = PIXI.Texture.fromImage(this.calcClass.imgDesc);
      let myDescSpr = new Sprite(myDescImg);
      myDescSpr.width = 691;
      myDescSpr.height = 160;
      myDescSpr.anchor.set(.5, .5);
      myDescSpr.position.set(375, 408);
      container.addChild(myDescSpr);

      // 海报插画
      let myIllusImg = PIXI.Texture.fromImage(this.calcClass.imgIllus);
      let myIllusSpr = new Sprite(myIllusImg);
      myIllusSpr.width = mySelected.illus.w;
      myIllusSpr.height = mySelected.illus.h;
      myIllusSpr.anchor.set(.5, .5);
      myIllusSpr.position.set(375, 700);
      container.addChild(myIllusSpr);

      // 海报副插画1
      if (mySelected.sub1) {
        let mySub1Img = PIXI.Texture.fromImage(this.calcClass.sub1);
        let mySub1Spr = new Sprite(mySub1Img);
        mySub1Spr.width = mySelected.sub1.w;
        mySub1Spr.height = mySelected.sub1.h;
        mySub1Spr.anchor.set(.5, .5);
        mySub1Spr.position.set(67, 78);
        container.addChild(mySub1Spr);
      }

      // 海报副插画2
      if (mySelected.sub2) {
        let mySub2Img = PIXI.Texture.fromImage(this.calcClass.sub2);
        let mySub2Spr = new Sprite(mySub2Img);
        mySub2Spr.width = mySelected.sub2.w;
        mySub2Spr.height = mySelected.sub2.h;
        mySub2Spr.anchor.set(.5, .5);
        mySub2Spr.position.set(682, 80);
        container.addChild(mySub2Spr);
      }

      // 分数样式
      let styleCommon = new PIXI.TextStyle({
        fontFamily: 'SimHei',
        fontSize: 40,
        // fontWeight: '700',
        fill: '#5cfff9',
        dropShadow: true,     //阴影
        dropShadowColor: '#5cfff9', //阴影颜色
        dropShadowBlur: 10,          //阴影模糊程度
        dropShadowAngle: 0, //阴影角度
        dropShadowDistance: 0,  //阴影距离
      });

      // 好奇心得分
      let idx1 = this.idx1;
      let score1 = `${idx1}%`;
      let genScore1 = new Text(score1, styleCommon);
      genScore1.anchor.set(.5, .5);
      genScore1.position.set(375, 48);
      container.addChild(genScore1);

      // 好运得分
      let idx2 = this.idx2;
      let score2 = `${idx2}%`;
      let genScore2 = new Text(score2, styleCommon);
      genScore2.anchor.set(.5, .5);
      genScore2.position.set(120, 162);
      container.addChild(genScore2);

      // 创新得分
      let idx3 = this.idx3;
      let score3 = `${idx3}%`;
      let genScore3 = new Text(score3, styleCommon);
      genScore3.anchor.set(.5, .5);
      genScore3.position.set(630, 162);
      container.addChild(genScore3);

      // 用户名样式
      let style1 = new PIXI.TextStyle({
        fontFamily: 'SimHei',
        fontSize: 40,
        // fontWeight: '700',
        fill: '#fff'
      });

      let title = this.title;
      let userTitle = `${this.person}获得${title}称号`;
      let genUserTitle = new Text(userTitle, style1);
      genUserTitle.anchor.set(.5, .5);
      genUserTitle.position.set(375, 298);
      container.addChild(genUserTitle);

      appStage.stage.addChild(container);

      setTimeout(() => {
        this.mergedSrc = appStage.renderer.plugins.extract.base64(appStage.stage);
      }, 800);
    }
  },
  watch: {
    person () {
      this.mergeImg();
      this.isSlideIn = true;
      setTimeout(() => {
        this.isSlideIn = false;
      }, 1000);
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
@import url('./common.less');

.pageTwo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-image: url('./poster-common-bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  .pt-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .index {
      position: relative;
      width: 18.4375rem /* 295/16 */;
      height: 6rem /* 96/16 */;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url('./poster-common-index.png');
      margin-top: 1.625rem /* 26/16 */;
      .idx {
        position: absolute;
        font-size: .875rem /* 14/16 */;
        line-height: 1.6;
        color: #5cfff9;
      }
      .idx1 {
        left: 8.5rem /* 136/16 */;
        top: -1.5rem /* 24/16 */;
      }
      .idx2 {
        left: .375rem /* 6/16 */;
        bottom: 2.5rem /* 40/16 */;
      }
      .idx3 {
        bottom: 2.5rem /* 40/16 */;
        right: 0;
      }
      .illusSub {
        position: absolute;
        background-repeat: no-repeat;
        background-size: cover;
      }
      .illus-left {
        top: -1.25rem /* 20/16 */;
        left: -.875rem /* 14/16 */;
      }
      .illus-right {
        top: -1.625rem /* 26/16 */;
        right: -.875rem /* 14/16 */;
      }
    }
    .person-title {
      font-size: 1.25rem /* 20/16 */;
      color: white;
      line-height: 1.4;
      .pt-title {
        color: #5cfff9;
        padding: 0 4px;
      }
    }
    .desc {
      margin: .625rem /* 10/16 */ 0;
      width: 21.625rem /* 346/16 */ * .9;
      height: 5rem /* 80/16 */ * .9;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .ils-wrapper {
      margin-bottom: .625rem /* 10/16 */;
      text-align: center;
      .illustration {
        height: 12.5rem /* 200/16 */ * .9;
        background-repeat: no-repeat;
        background-size: cover;
        margin-bottom: .625rem /* 10/16 */;
      }
      .ils-desc {
        width: 16.0625rem /* 257/16 */;
        height: 2.0625rem /* 33/16 */;
        background-image: url('./poster-common-desc.png');
        background-repeat: no-repeat;
        background-size: cover;
        margin-bottom: .625rem /* 10/16 */;
      }
      .long-press {
        display: inline-block;
        width: 5.25rem /* 84/16 */;
        height: .75rem /* 12/16 */;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('./long-press.png');
      }
    }
    .btn-group {
      z-index: 3;
      .btn {
        display: inline-block;
        width: 9.5625rem /* 153/16 */;
        height: 2.8125rem /* 45/16 */;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .btn-left {
        background-image: url('./btn-again.png');
      }
      .btn-right {
        background-image: url('./btn-share.png');
      }
    }
    .logo-group {
      display: flex;
      justify-content: space-between;
      width: 8.75rem /* 140/16 */;
      .logo {
        display: inline-block;
        width: 2.9375rem /* 47/16 */;
        height: 2.9375rem /* 47/16 */;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .logo-left {
        background-image: url('./logo-hw.png');
      }
      .logo-right {
        background-image: url('./logo-gk.png');
      }
    }
  }
  .mergedImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 23.4375rem /* 375/16 */;
    // z-index: 5;
    opacity: 0;
  }
  #myCanvas {
    display: none;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .8);
    z-index: 5;
    .router {
      position: absolute;
      top: .625rem /* 10/16 */;
      right: .625rem /* 10/16 */;
      width: 4.0625rem /* 65/16 */;
      height: 14.3125rem /* 229/16 */;
      background-image: url('./poster-pop.png');
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}

.slideIn {
  animation: slideIn .4s ease-out;
  animation-fill-mode: both;
}

@keyframes slideIn {
  from {
    opacity: 0.1;
  }
  to {
    opacity: 1;
  }
}

</style>
